
import { Tooltip } from "@mui/material";
import { makeStyles } from '@mui/styles';

export default function AximTooltip (props) {
    
  const useStyles = makeStyles((theme) => ({
    arrow: {
      color: theme.palette?.primary?.main
    },
    tooltip: {
      color: theme.palette?.primary?.contrastText
    }
  }));

    const classes = useStyles();

    return (
        <Tooltip classes={{ arrow: classes.arrow, tooltip: classes.tooltip }} {...props} />
    )
}